import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const alphanumericValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value: string = control.value || '';
  const hasLetter = /[a-zA-Z]/.test(value);
  const hasNumber = /\d/.test(value);
  return value.length > 0 && hasLetter && hasNumber ? null : { alphanumeric: true };
};

export const specialCharacterValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value: string = control.value || '';
  const specialCharRegex = /[^a-zA-Z0-9\s]/;
  return value.length > 0 && specialCharRegex.test(value) ? null : { specialCharacter: true };
};

export const sequentialValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const error = { sequential: true };

  const value = (control.value || '').toLowerCase();

  if (value.length === 0) return error;

  const chars = value.split('').map((c: string) => c.charCodeAt(0));

  for (let i = 0; i <= chars.length - 4; i++) {
    const isAsc = chars[i + 1] === chars[i] + 1 && chars[i + 2] === chars[i + 1] + 1;
    const isDesc = chars[i + 1] === chars[i] - 1 && chars[i + 2] === chars[i + 1] - 1;
    if (isAsc || isDesc) {
      return error;
    }
  }

  return null;
};

export function matchFieldsValidator(field1: string, field2: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const value1 = group.get(field1)?.value;
    const value2 = group.get(field2)?.value;

    if (value1 === value2) {
      return null;
    }

    return { fieldsMismatch: true };
  };
};
